module.exports = __webpack_public_path__ + "img/icn-marine-corps.b54e1d67.png";